import { Number, Record, String } from "runtypes";

export const Score = Record({
  label: String,
  value: Number.nullable(),
});
